/**
 * Never in a draft or browser storage (Pete, 2026-10-10): passwords, access
 * codes, MFA codes, tokens. A field whose NAME looks like one of these is
 * dropped, and so is any VALUE that looks like a token (a JWT) or a signed
 * link (an S3 presigned URL carries a signature and, for temporary
 * credentials, a security token). Same rule as the staff app's
 * src/utils/noSecrets.js; this copy adds the signed-link check.
 *
 * The one stated exception: Amplify's own Cognito session keys (the library,
 * not this code) — CLAUDE.md rule 8.
 */

export const SECRET_NAME =
  /pass(word|code|phrase)?|pwd|access.?code|code.?input|mfa|otp|totp|token|secret|credential|api.?key|authori[sz]ation|session|report.?url|download.?url|upload.?url/i;

/** header.payload.signature, base64url — a Cognito ID/access token. */
export const JWT_VALUE = /eyJ[A-Za-z0-9_-]{8,}\.[A-Za-z0-9_-]{8,}\.[A-Za-z0-9_-]{8,}/;

/** A presigned S3 link (SigV4 or SigV2). */
export const SIGNED_URL_VALUE = /X-Amz-(Signature|Security-Token|Credential)=|[?&]Signature=/i;

export function stripSecrets(value) {
  if (typeof value === 'string') return JWT_VALUE.test(value) || SIGNED_URL_VALUE.test(value) ? '' : value;
  if (Array.isArray(value)) return value.map(stripSecrets);
  if (value && typeof value === 'object') {
    const out = {};
    for (const [k, v] of Object.entries(value)) {
      if (SECRET_NAME.test(k)) continue;
      out[k] = stripSecrets(v);
    }
    return out;
  }
  return value;
}
